import React, { useRef } from 'react';
import Link from './Link';

import BlockContent from '@sanity/block-content-to-react';
import richText from '../serializers/richText';
import useIntersection from 'buena-suerte/lib/hooks/useIntersection';
import classNames from 'classnames';

export default ({ designer }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);

  return (
    <section
      ref={intersectionRef}
      className={classNames('featured-designer df bt--dark-brown reveal', {
        revealed: isIntersected,
      })}
    >
      <div className="featured-designer__details p2 p5--lg">
        <div className="title df mb1 aib">
          <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
            Designer
          </p>
          <h2 className="sans--md">{designer.title}</h2>
        </div>
        {designer.url && (
          <div className="title df mb1 aib">
            <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
              URL
            </p>
            <a href={designer.url} className="sans--sm ">
              Website
            </a>
          </div>
        )}
        <div className="title df mb1 aib">
          <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
            Description
          </p>
          {designer.pdpDescription && (
            <div className="sans--sm  rich-text">
              <BlockContent
                blocks={designer.pdpDescription}
                serializers={richText}
              />
            </div>
          )}
        </div>
        {designer.links.length && (
          <ul className="featured-designer__links">
            {designer.links.map(link => {
              return (
                <li key={link._key}>
                  <div className="title df mb1 aib">
                    <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
                      {link.type && link.type}
                    </p>
                    <div className="sans--sm  rich-text link--underline">
                      <Link className="link--underline" {...link} />
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
      <div className="featured-designer__img">
        <picture>
          <source
            srcSet={`${designer.image.url}?w=1200&auto=format&q=100`}
            media="(min-width: 1000px)"
          />
          <source
            srcSet={`${designer.image.url}?w=600&auto=format&q=100`}
            media="(min-width: 600px)"
          />
          <img
            alt={designer.image.alt}
            className="db"
            src={`${designer.image.url}?w=600&auto=format&q=100`}
          />
        </picture>
      </div>
    </section>
  );
};
